import { type JwtPayload } from 'jsonwebtoken'

export function decodeJwtPayload(token: string): JwtPayload {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')

  return JSON.parse(atob(base64))
}
